import styles from './Comment.module.css';

type Props = {
  replyCount: Number;
  showReplies: Boolean;
  setShowReplies: Function;
};

export default function ToggleReplies(props: Props) {
  return (
    <button
      className={styles.CommentAction}
      onClick={() => props.setShowReplies(!props.showReplies)}
    >
      {!props.showReplies && props.replyCount === 1 && 'Show Reply'}
      {!props.showReplies &&
        props.replyCount > 1 &&
        `Show ${props.replyCount} Replies`}
      {props.showReplies && 'Hide Replies'}
    </button>
  );
}
